// Add your custom JS here.
( function( $ ) {


    // Fade in effects
    AOS.init();
    


    // Smooth anchor scrolling
    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 300
    });



    // vimeo functions
    const iframe = document.querySelector("#vimeoplayer");
    const player = new Vimeo.Player(iframe);

    const aniiframe = document.querySelector("#animationplayer");
    const aniplayer = new Vimeo.Player(aniiframe);

    $(".animation, .section-two .fold-video").on("click", function () {
        $(".header-animation").fadeIn(150);
        aniplayer.play();
    });

    $(".close").on("click", function () {
        $(".header-animation").fadeOut(150);
        aniplayer.pause();
    });

    $("#wrapper-navbar .play, .section-five .play-button, .section-one .fold-video").on("click", function () {
        $(".header-film").fadeIn(150);
        player.play();
    });

    $(".header-film .close").on("click", function () {
        $(".header-film").fadeOut(150);
        player.pause();
    });






    // counter
    $(".page-template-location .section-two .keys h2").countUp();
    



    // check if page is scrolled from the top for header
    // $(document).scroll(function(){
    //     if($(this).scrollTop() > 50)
    //     {   
    //         $('#wrapper-navbar').addClass('off-top');

    //     }
    //     if($(this).scrollTop() < 50)
    //     {   
    //         $('#wrapper-navbar').removeClass('off-top');
    //     }
    // });



    // show header based on scroll directions
    // var lastScrollTop = 0;
    // $(window).scroll(function(event){
    //     var st = $(this).scrollTop();
    //     if (st > lastScrollTop){
    //         $('#wrapper-navbar').addClass('hide');
    //     } else {
    //         $('#wrapper-navbar').removeClass('hide');
    //     }
    //     lastScrollTop = st;
    // });


    
    // Swiper example
    // var swiper = new Swiper(".carouselname-swiper", {
    //     slidesPerView: "auto",
    //     center: true,
    //     loop: false,
    //     pagination: {
    //         el: ".carouselname-pagination",
    //         clickable: true,
    //         renderBullet: function (index, className) {
    //             return '<span class="' + className + '"></span>';
    //         },
    //     },
    //     navigation: {
    //         nextEl: ".carouselname-next",
    //         prevEl: ".carouselname-prev",
    //     },
    //     breakpoints: {
    //         768: {
    //           spaceBetween: 500,
    //         },
    //         1024: {
    //           spaceBetween: 500,
    //         },
    //       },
    // });



    // click example
    // $(".menu-toggle").on("click", function () {
    //     $(this).toggleClass('active');
    //     $('#wrapper-navbar').toggleClass('active');
    // });





    // parallax effects
    var image = document.getElementsByClassName('parallax-img');
    new simpleParallax(image);


    var sentenceright = document.getElementsByClassName('sentence-top');
    new simpleParallax(sentenceright, {
        overflow: true,
        orientation: "left",
        scale: 2,
    });

    var sentenceleft = document.getElementsByClassName('sentence-bottom');
    new simpleParallax(sentenceleft, {
        overflow: true,
        orientation: "right",
        scale: 2,
    });




    // Fold swiper 
    var foldswiper = new Swiper(".fold-swiper", {
        slidesPerView: 1,
        center: true,
        loop: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        }, 
        effect: "fade",
    });




    // page submenu functionalities
    $(window).scroll(function() {
        // Calculate the distance scrolled
        var distanceScrolled = $(window).scrollTop();

        // Calculate the threshold (100vh + 100px)

        if ($("body").hasClass("page-template-contact")) {
            var threshold = ($(window).height() * 0.66) + 85;
        }

        else if ($("body").hasClass("page-template-gallery")) {
            var threshold = ($(window).height() * 0.5) + 65;
        }

        else {
            var threshold = $(window).height() - 15;
        }

        // Check if the distance scrolled is greater than the threshold
        if (distanceScrolled > threshold) {
            // Add the class to your target element
            $('.page-menu').addClass('active');
        } else {
            // Remove the class if the user scrolls back above the threshold
            $('.page-menu').removeClass('active');
        }
    });

    if ($(".page-menu").length) {
        $(".page-menu li:first-child a").addClass("active");

        $(window).on("scroll", function () {
            $(".anchor").each(function () {
                if ($(window).scrollTop() >= $(this).offset().top - 50) {
                    var currentItem = $(this).attr("id");
                    $(".page-menu a").removeClass("active");
                    $("." + currentItem).addClass("active");
                }
            });
        });
    }

    $(".page-nav a").on("click", function () {
        $(".page-nav a").removeClass("active");
        $(this).addClass("active");
    });








    // mobile menu toggle
    $(".menu-icon").on("click", function () {
        $("#wrapper-navbar").toggleClass('active');
        $("#wrapper-navbar .right").fadeToggle();
    });





    // location image raster

    if ($("body").hasClass("page-template-location")) {

        // location map functionalities

        if ($(window).width() > 992) {
            var mapInfoHeight = $("#location-wrapper .section-nine .info").height() / 2 + 10; 
            $("#location-wrapper .section-nine .info").css("height", mapInfoHeight);
        }

        $("#location-wrapper .section-nine .toggle").on("click", function () {
            if (!$(this).hasClass('active')) {

                $(this).siblings().removeClass('active');
                $(this).addClass('active');

                $("#location-wrapper .maps").toggleClass('active');
            }
        });
    
        // location city guide functionalities
        $("#location-wrapper .section-ten .button").on("click", function () {
            $(this).slideUp();
            $("#location-wrapper .section-ten .location").slideDown();
        });

        $("#location-wrapper .section-ten .toggle").on("click", function () {
            if (!$(this).hasClass('active')) {

                $("#location-wrapper .section-ten .button").slideUp();

                $(this).siblings().removeClass('active');
                $(this).addClass('active');
                var activeLocations = $(this).attr("type");

                $(".locations").scrollLeft(0);

                $( "#location-wrapper .locations").slideUp(function() {

                    $(".location").css("display", "none");
                    $(".location." + activeLocations + "").css("display", "block");

                    $("#location-wrapper .locations").slideDown();
                    
                });
            }
        });


        if ($(window).width() < 992) {
            $("#location-wrapper .mobile-view-toggle").on("click", function () {
                $(this).siblings().slideDown();
                $(this).slideUp();
            });

            $(".section-nine .toggle").on("click", function () {
                $(".section-nine .info").slideUp();
                $(".mobile-view-toggle").slideDown(0);
            });
        }
    }




    // Home keys swiper

    if ($("body").hasClass("page-template-frontpage")) {

        if ($(window).width() < 992) {
            $(".section-two .key").wrapAll("<div class='swiper keys-swiper'><div class='swiper-wrapper'></div></div>");
            
            var $items = $('.section-two .key'); 

            for (var i = 0; i < $items.length; i += 3) {
                $items.slice(i, i + 3).wrapAll('<div class="swiper-slide"></div>');
            }

            $(".section-two .keys").append("<div class='keys-swiper-navigation'><div class='keys-swiper-prev'></div><div class='keys-swiper-next'></div></div>");

            var keysswiper = new Swiper(".keys-swiper", {
                slidesPerView: 1,
                navigation: {
                    nextEl: ".keys-swiper-next",
                    prevEl: ".keys-swiper-prev",
                },
            });
        }
    }




    // Home gallery container
    if ($(window).width() > 992) {

        $(".page-template-frontpage .section-three .image:nth-child(2), .page-template-frontpage .section-three .image:nth-child(3)").wrapAll("<div class='middle-wrapper'></div>");

        var viewportWidth = $(window).width();
        var containerwidth = 1130;
        var imageswidth = (viewportWidth - containerwidth) / 2 + containerwidth;

        $(".page-template-frontpage .section-three .images").css("width", imageswidth);
    }





    // Building swiper 
    var buildingswiper = new Swiper(".building-swiper", {
        slidesPerView: "auto",
        spaceBetween: 70,
        navigation: {
            nextEl: ".building-swiper-next",
            prevEl: ".building-swiper-prev",
        },
    });



    if ($("body").hasClass("page-template-building")) {
        if ($(window).width() < 992) {
            $(".section-two .buildingkey").wrapAll("<div class='swiper buildingkeys-swiper'><div class='swiper-wrapper'></div></div>");
            
            var $items = $('.section-two .buildingkey').wrap("<div class='swiper-slide'></div>");

            $(".section-two .buildingkeys").append("<div class='buildingkeys-swiper-navigation'><div class='buildingkeys-swiper-prev'></div><div class='buildingkeys-swiper-next'></div></div>");

            var buildingkeysswiper = new Swiper(".buildingkeys-swiper", {
                slidesPerView: "auto",
                spaceBetween: 50,
                navigation: {
                    nextEl: ".buildingkeys-swiper-next",
                    prevEl: ".buildingkeys-swiper-prev",
                },
            });





            $(".section-four .key").wrapAll("<div class='swiper specifications-swiper'><div class='swiper-wrapper'></div></div>");
            
            var $items = $('.section-four .key'); 

            for (var i = 0; i < $items.length; i += 2) {
                $items.slice(i, i + 2).wrapAll('<div class="swiper-slide"></div>');
            }

            $(".section-four .keys").append("<div class='specifications-swiper-navigation'><div class='specifications-swiper-prev'></div><div class='specifications-swiper-next'></div></div>");

            var specificationsswiper = new Swiper(".specifications-swiper", {
                slidesPerView: 2,
                navigation: {
                    nextEl: ".specifications-swiper-next",
                    prevEl: ".specifications-swiper-prev",
                },
            });
        }
    }




    // esg mobile swiper
    if ($("body").hasClass("page-template-esg")) {
        if ($(window).width() < 992) {

            $(".section-two .key").wrapAll("<div class='swiper esg-swiper'><div class='swiper-wrapper'></div></div>");
            
            var $items = $('.section-two .key'); 

            for (var i = 0; i < $items.length; i += 2) {
                $items.slice(i, i + 2).wrapAll('<div class="swiper-slide"></div>');
            }

            $(".section-two .keys").append("<div class='esg-swiper-navigation'><div class='esg-swiper-prev'></div><div class='esg-swiper-next'></div></div>");

            var esgswiper = new Swiper(".esg-swiper", {
                slidesPerView: "auto",
                spaceBetween: 50,
                navigation: {
                    nextEl: ".esg-swiper-next",
                    prevEl: ".esg-swiper-prev",
                },
            });

        }
    }




    // Building feature functionalities 
    $("#building-wrapper .section-three .toggle:first-child").addClass('active');
    $("#building-wrapper .section-three .feature:first-child").addClass('active').css("display", "block");

    $("#building-wrapper .section-three .toggle").on("click", function () {
        if (!$(this).hasClass('active')) {

            $(this).siblings().removeClass('active');
            $(this).addClass('active');

            var featureId = $(this).attr("feature");


            $( "#building-wrapper .section-three .feature.active").removeClass('active').fadeOut(function() {
                $("#building-wrapper .section-three #feature-" + featureId + "").fadeIn();
                $("#building-wrapper .section-three #feature-" + featureId + "").addClass('active');
            });
        }
    });

    var featureIndex = 1;
    $(".feature-swiper").each(function(){ 

        var featureswiper = new Swiper(".feature-swiper-" + featureIndex + "", {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 70,
            navigation: {
                nextEl: ".feature-swiper-next-" + featureIndex + "",
                prevEl: ".feature-swiper-prev-" + featureIndex + "",
            },
        });
        featureIndex++;
    });


    // availability stacker functionalities

    if ($("body").hasClass("page-template-availability")) {

        $(window).load(function() {

            $(".stacklayer").on("mouseover", function () {
                var floorId = $(this).attr("floor");
                $(".stacklayer[floor='" + floorId + "']").addClass('active');
            });

            $(".stacklayer").on("mouseout", function () {
                $(".stacklayer").removeClass('active');
            });

        
            $(".swiper-slide").each(function(){ 
                var height = $(this).find("img, iframe").height();
                $(this).find("div").height(height);
            });

            var planIndex = 1;
            $(".plans-tab").each(function(){ 

                var featureswiper = new Swiper(".plan-swiper-" + planIndex + "", {
                    loop: false,
                    autoHeight: true,
                    slidesPerView: 1,
                    navigation: {
                        nextEl: ".plan-swiper-next-" + planIndex + "",
                        prevEl: ".plan-swiper-prev-" + planIndex + "",
                    },
                });
                planIndex++;
            });

            $(".plans-tab, .floor-plans").css("display", "none");
            $(".plans-tab").addClass('done');
            $(".floor-plans:last-child, .plans-tab:first-child").css("display", "block");
            $(".floor-toggle:last-child, .plan-toggle:first-child, .floor-plans:last-child, .plans-tab:first-child").addClass('active');

            $(".floor-toggle").on("click", function () {

                if(!$(this).hasClass('active')) {
                    var rowIndex = $(this).attr("rowindex");

                    $(".floor-toggle").removeClass('active');
                    $(".floor-toggle[rowindex='" + rowIndex + "']").addClass('active');

                    $( ".floor-plans.active").removeClass('active').fadeOut(function() {
                        $(".floor-plans[rowindex='" + rowIndex + "']").fadeIn().addClass('active');

                        $( ".section-three iframe" ).each(function() {
                            $(this).attr( 'src', function ( i, val ) { return val; });
                        });
                    });
                }
            });

            $(".plan-toggle").on("click", function () {

                if(!$(this).hasClass('active')) {

                    var planIndex = $(this).attr("planindex");
                    
                    $(this).siblings().removeClass('active');
                    $(this).addClass('active');

                    $(this).parent().siblings().children(".active").removeClass('active').fadeOut(function() {
                        $(this).siblings(".plans-tab[planindex='" + planIndex + "']").fadeIn().addClass('active');

                        $( ".section-three iframe" ).each(function() {
                            $(this).attr( 'src', function ( i, val ) { return val; });
                        });
                    });
                }
            });

            $(".section-two .plan-toggle").on("click", function () {
                var floorname = $(this).parent().siblings(".floor").text();
                $(".floor-toggles-wrapper span").text(floorname);
            });

            $(".stacker .plan-toggle").on("click", function () {
                var floorindex = $(this).attr("plan");
                $(".floor-toggle[rowindex='" + floorindex + "'").click();
            });

            const niaElements = $('.stacker-row .nia');
            var niaTotal = 0;

            var receptionSize = $(".stacker-row:last-child .nia").html().replace(/,/g, '');

            var niaTotal = niaTotal - receptionSize;

            niaElements.each(function() {
                const niaValue = parseFloat($(this).html().replace(/,/g, ''));
                niaTotal += niaValue;
            });



            const niaFormat = niaTotal.toLocaleString('en-US');
            $('.stacker-total .nia').text(niaFormat);

            $(".stacker .select-toggle").on("click", function () {
                $(this).toggleClass('active');

                const niaElementsSelected = $('.stacker-row .select-toggle.active').parent().siblings(".nia");
                let niaTotalSelected = 0;
                niaElementsSelected.each(function() {
                    const niaSelectedValue = parseFloat($(this).html().replace(/,/g, ''));
                    niaTotalSelected += niaSelectedValue;
                });

                const niaSelectedFormat = niaTotalSelected.toLocaleString('en-US');
                $('.stacker-selected .nia').text(niaSelectedFormat);
            });

            const terraceElements = $('.stacker-row .terrace');
            let terraceTotal = 0;
            terraceElements.each(function() {

                const terraceValue = $(this).html();

                if (!terraceValue.includes('-')) {
                    const terraceNumericValue = parseInt(terraceValue.replace(/,/g, '').replace('-', ''));
                    terraceTotal += terraceNumericValue;
                }
            });

            const terraceFormat = terraceTotal.toLocaleString('en-US');
            $('.stacker-total .terrace').text(terraceFormat);

            $(".stacker .select-toggle").on("click", function () {

                const terraceElementsSelected = $('.stacker-row .select-toggle.active').parent().siblings(".terrace");
                let terraceTotalSelected = 0;
                terraceElementsSelected.each(function() {

                    const terraceSelectedValue = $(this).html();

                    if (!terraceSelectedValue.includes('-')) {
                        const terraceSelectedNumericValue = parseInt(terraceSelectedValue.replace(/,/g, '').replace('-', ''));
                        terraceTotalSelected += terraceSelectedNumericValue;
                    }
                });

                const terraceSelectedFormat = terraceTotalSelected.toLocaleString('en-US');
                $('.stacker-selected .terrace').text(terraceSelectedFormat);
            });

            if ($(window).width() < 992) {
                $(".floor-toggles").wrap("<div class='floor-toggles-wrapper'></div>");
                $(".floor-toggles-wrapper").prepend("<div class='floor-toggles-spanwrapper'><span>Reception</span></div>");

                $(".section-three .floors .floor-toggles-spanwrapper").on("click", function () {
                    $(".floor-toggles").fadeToggle();
                });

                $(".section-three .floors .floor-toggle").on("click", function () {
                    $(".floor-toggles").fadeOut();
                });

                $(".floor-toggle").on("click", function () {
                    var floorname = $(this).text();

                    $(".floor-toggles-wrapper span").text(floorname);
                });
            }
        });

    }




    // gallery functionalities
    $(".tab:first-child, .toggle:first-child").addClass('active').css("display", "block");

    $(".toggle").on("click", function () {
        if(!$(this).hasClass('active')) {

            $(this).siblings().removeClass('active');
            $(this).addClass('active');

            var index = $(this).attr("tab");

            $(".tab.active").removeClass('active').fadeOut(function() {
                $("#tab-" + index + "").addClass('active').fadeIn();
            });
        }
    });

    var galleryswiper = new Swiper(".gallery-swiper", {
        slidesPerView: "auto",
        navigation: {
            nextEl: ".gallery-swiper-next",
            prevEl: ".gallery-swiper-prev",
        },
    });

    $(".tab .images .image").on("click", function () {
        $(".lightbox-gallery").addClass('active');
        var index = $(this).attr("image") - 1;
        galleryswiper.slideTo(index, 0, false);
    });

    $(".lightbox-gallery .close").on("click", function () {
        $(".lightbox-gallery").removeClass('active');
    });




    // download functionalities
    $(".page-template-downloads .download-button").on("click", function (e) {
        if ($("body").hasClass("subscribed")) {
            var currentfileLink = $(this).attr("downloadlink");
            var currentfileName = $(this).attr("filename");
            $("#saentysfdbm").attr("href", currentfileLink);
            $("#saentysfdbm").attr("download", currentfileName);
            $("#saentysfdbm")[0].click();
        } else {
            var currentdownload = $(this).children("p").text();



            $(".download-popup h2").text(currentdownload);
            $(".download-popup .ginput_container_text input").val(currentdownload);
            $(".popup-shadow").addClass("active");
            $(".download-popup").addClass("active");
            var currentfileLink = $(this).attr("downloadlink");
            var currentfileName = $(this).attr("filename");
            $("#saentysfdbm").attr("href", currentfileLink);
            $("#saentysfdbm").attr("download", currentfileName);
            $(document).on("gform_confirmation_loaded", function (e, form_id) {
                $("body").addClass("subscribed");
                $("#saentysfdbm")[0].click();
            });
        }
    });

    $(".download-popup .close, .popup-shadow").on("click", function (e) {
        $(".popup-shadow").removeClass("active");
        $(".download-popup").removeClass("active");
    });





    // line animations


  // Function to check if an element's bottom is in the viewport
  function isElementBottomInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
      rect.bottom >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) - ($(window).height() * 0.2) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  // Function to add the "active" class to elements with bottom in the viewport
  function addActiveClassToLines() {
    $(".line, .page-template-frontpage .section-three .image-inner, .image-inner-inner").each(function () {
    if (isElementBottomInViewport(this)) {
        $(this).addClass("active");
    }
    });
  }

  // Initially add the "active" class to elements in the viewport on page load
  addActiveClassToLines();

  // Add the "active" class to elements as the user scrolls
  $(window).on("scroll", function () {
    addActiveClassToLines();
  });




    // Function to check if an element's bottom is in the viewport
    function isSectionBottomInViewport(el) {
        var rect = el.getBoundingClientRect();
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.top <= (window.innerHeight || document.documentElement.clientHeight) - ($(window).height() * 0.4) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
      }
    
      // Function to add the "active" class to elements with bottom in the viewport
      function addActiveClassToSections() {
        $(".backanimation").each(function () {
        if (isSectionBottomInViewport(this)) {
            $(this).addClass("active");
        }
        });
      }
    
      // Initially add the "active" class to elements in the viewport on page load
      addActiveClassToSections();
    
      // Add the "active" class to elements as the user scrolls
      $(window).on("scroll", function () {
        addActiveClassToSections();
      });


} )( jQuery );